module.exports = __webpack_public_path__ + "img/step3.4dd45b11.png";